import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { CreateViewPickerComponent } from '../create-view-picker/create-view-picker.component';
import { Project } from 'src/app/model/project/project';
import {
  SUB_PROJECT_TYPES,
  SubProject,
} from 'src/app/model/project/sub-project';
import { RequestService } from 'src/app/services/request.service';
import { SnackService } from 'src/app/services/snack.service';
import { BaseProject } from 'src/app/model/project/base-project';
import { Adjustment } from 'src/app/model/project/adjustment';
import { SoldRented } from 'src/app/model/project/sold-rented';
import { Repo } from 'src/app/model/project/repo';
import ProjectHelper from 'src/app/helpers/project-helper';
import { Subject } from 'rxjs';
import Product from 'src/app/model/product/product';
import { SubProjectCount } from 'src/app/helpers/sub-project-count';
import Contact from 'src/app/model/Contact/contact';
import { CreateViewProjectHelper } from './helper/create-view-project-helper';
import { ClientCompanySelectService } from 'src/app/services/client-company-select.service';
import { CreateBaseProjectUrlParamsService } from '../../../../services/create-base-project-url-params.service';
import { ExternalParty } from '../../../../model/user';
import { STATUS } from '../../../../model/project/status';

@Component({
  selector: 'create-view-project',
  templateUrl: './create-view-project.component.html',
  styleUrls: ['./create-view-project.component.scss'],
})
export class CreateViewProjectComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  @ViewChild(CreateViewPickerComponent)
  childcomp: CreateViewPickerComponent;

  @Input()
  project: Project;

  @Input()
  model: SubProject;

  @Input()
  newSubProjectType: string;

  @Input()
  adminCreate: boolean = false;

  @Output()
  submitProject = new EventEmitter();

  @Output()
  closeCurrentTab = new EventEmitter();

  activeSubProject: SubProject;

  init = false;

  forceRefresh = new EventEmitter();

  subProjectCount: SubProjectCount;

  selectedOtherContacts: Contact[];

  submitProjectResult: Subject<any>;

  constructor(
    private requestService: RequestService,
    private snackService: SnackService,
    private clientCompanySelectService: ClientCompanySelectService,
    private createBaseProjectUrlParamsService: CreateBaseProjectUrlParamsService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    if (this.project.id != null) {
      this.addSubscription(
        this.requestService.getNormal('/projects/' + this.project.id),
        (project) => {
          if (project.subProjects[0]?.status == STATUS.DRAFT.valueOf()) {
            this.initDraftProject(project);
          } else {
            this.initProject(project, true);
          }
        },
        () => {
          this.initNewProject();
        }
      );
    } else {
      this.initNewProject();
    }
  }

  private initNewProject() {
    if (
      this.project.id != null &&
      this.model.id == null &&
      this.newSubProjectType == null
    ) {
      this.snackService.showError('Geen subproject id meegegeven');
      return;
    }
    if (this.project.id == null) {
      this.model = new BaseProject();
      this.project.subProjects = [this.model];
      this.project.products = [new Product()];
      this.activeSubProject = this.model;
      this.submitProjectResult = new Subject<any>();
      this.createSubmitProjectSubscription();

      this.subProjectCount = new SubProjectCount(this.project, true);
      this.init = true;
      return;
    }
    if (this.model.id == null && this.newSubProjectType != null) {
      if (this.newSubProjectType === 'Adjustment') {
        this.model = new Adjustment();
      } else if (this.newSubProjectType === 'SoldRented') {
        this.model = new SoldRented();
      } else if (this.newSubProjectType === 'Repo') {
        this.model = new Repo();
      } else {
        this.snackService.showError(
          'Nieuw type subproject niet herkend: ' + this.newSubProjectType
        );
        return;
      }
      if (this.project.subProjects != null) {
        this.project.subProjects.push(this.model);
      }
      this.activeSubProject = this.model;

      this.addSubscription(this.submitProject, () => {
        this.setProjectNullInSubProjects();
        this.addSubscription(
          this.requestService.put(this.project, '/projects'),
          () => {
            this.snackService.showSuccess('Project succesvol aangevraagd');
            let tabClose = {
              componentClass: 'CreateViewProjectComponent',
              project: this.project,
            };
            this.closeCurrentTab.emit(tabClose);
          }
        );
      });
    }
    this.addSubscription(
      this.requestService.getNormal('/projects/' + this.project.id),
      (res) => {
        this.initProject(res, this.newSubProjectType == null);
      }
    );
    this.addSubscription(
      this.forceRefresh,
      () => {
        this.init = true;
      },
      () => {},
      100
    );
  }

  private createSubmitProjectSubscription() {
    this.addSubscription(this.submitProject, () => {
      if (
        !this.project.collaborative &&
        this.project.projectExtraCompanyContacts != null
      ) {
        delete this.project.projectExtraCompanyContacts;
      }
      this.addSubscription(
        this.requestService.post(
          this.getSubmitBaseProjectRequest(),
          '/projects/submitProject',
          'json'
        ),
        () => {
          CreateViewProjectHelper.updateClientSelectedCompanyAfterSubmit(
            this.project,
            this.clientCompanySelectService
          );
          this.submitProjectResult.next(true);
          this.snackService.showSuccess('Project succesvol aangevraagd');
          let tabClose = {
            componentClass: 'CreateViewProjectComponent',
            project: this.project,
          };
          this.closeCurrentTab.emit(tabClose);
        },
        () => this.submitProjectResult.next(false)
      );
    });
  }

  private initDraftProject(project: Project) {
    this.initProject(project, true);

    this.addSubscription(this.submitProject, () => {
      this.setProjectNullInSubProjects();
      this.addSubscription(
        this.requestService.put(this.project, '/projects'),
        () => {
          this.snackService.showSuccess('Project succesvol aangevraagd');
          let tabClose = {
            componentClass: 'CreateViewProjectComponent',
            project: this.project,
          };
          this.closeCurrentTab.emit(tabClose);
        }
      );
    });
    //this.createSubmitProjectSubscription();
    CreateViewProjectHelper.updateClientSelectedCompanyAfterSubmit(
      this.project,
      this.clientCompanySelectService
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.submitProjectResult != null) {
      this.submitProjectResult.complete();
      this.submitProjectResult = null;
    }
  }

  setProjectNullInSubProjects() {
    if (
      this.project.subProjects != null &&
      this.project.subProjects.length > 0
    ) {
      this.project.subProjects.forEach((sp) => {
        sp.project = null;
      });
    }
  }

  initProject(project: Project, tryFindSubProject = true) {
    if (project.subProjects == null) {
      this.snackService.showError('Project heeft geen subprojecten');
      return;
    }
    this.project = project;
    if (tryFindSubProject) {
      let initSubProject: SubProject = null;

      if (project.subProjects[0].status == STATUS.DRAFT) {
        initSubProject = project.subProjects[0];
      } else {
        const baseProject = ProjectHelper.getBaseProject(project);
        if (baseProject) {
          this.router.navigate(['klant-opdracht', project.id, baseProject.id]);
          return;
        }

        for (let subProject of this.project.subProjects) {
          if (subProject.id == this.model.id) {
            initSubProject = subProject;
            break;
          }
        }
      }
      if (initSubProject == null) {
        this.snackService.showError(
          'Subproject met id ' +
            this.model.id +
            ' niet teruggevonden in project'
        );
        return;
      }
      this.model = initSubProject;
      this.activeSubProject = initSubProject;
      this.subProjectCount = new SubProjectCount(this.project, true);
      this.project.products = [new Product()];
      this.calculateSubProjectsExecuted();
      this.init = true;
      return;
    }
    if (this.project.id != null && this.model.id == null) {
      let baseProject = ProjectHelper.getBaseProject(this.project);
      if (baseProject != null) {
        let address = {
          ...baseProject.projectPlacement.address,
        };
        delete address.id;
        delete address.coordinates;
        this.model.projectPlacement.address = address;
      }
      if (this.project.subProjects != null) {
        this.project.subProjects.push(this.model);
      }
      this.subProjectCount = new SubProjectCount(this.project, true);
      this.init = true;
    }
  }

  doSubmitProject() {
    this.submitProject.emit();
  }

  getTitle(sub: SubProject) {
    if (
      sub.type !== SUB_PROJECT_TYPES.BASE_PROJECT &&
      sub.id != null &&
      this.subProjectCount != null
    ) {
      return this.subProjectCount.getTabTitleDisplay(
        sub,
        false,
        this.project.oldPlatformId
      );
    } else {
      let title = ProjectHelper.getSubProjectTypeTitle(
        sub,
        true,
        sub.id != null || sub.status !== STATUS.DRAFT.valueOf()
      );
      if (sub.status === STATUS.DRAFT.valueOf()) {
        title += ' ' + this.project.id;
      }
      return title;
    }
  }

  openTab(subproject: SubProject) {
    this.activeSubProject = subproject;
    this.init = false;
    this.forceRefresh.emit();
  }

  getActive(subproject: SubProject) {
    return subproject.id == this.activeSubProject.id;
  }

  calculateSubProjectsExecuted() {
    if (this.project == null || this.project.subProjects == null) {
      return;
    }
    this.project.subProjects.forEach(
      (sp) =>
        (sp.showExecutedCheck = ProjectHelper.getIsExecuted(sp, this.project))
    );
  }

  setSelectedOtherContacts(contacts: Contact[]): void {
    this.selectedOtherContacts = contacts;
  }

  private getSubmitBaseProjectRequest(): SubmitBaseProjectRequest {
    return {
      project: CreateViewProjectHelper.cloneProject(this.project),
      otherContactIds:
        this.selectedOtherContacts == null
          ? null
          : this.selectedOtherContacts.map((c) => c.id),
      externalProjectIntegration: this.getExternalPartyFromParams(),
    };
  }

  private getExternalPartyFromParams(): ExternalProjectIntegration {
    const params =
      this.createBaseProjectUrlParamsService.getCreateBaseProjectUrlParams();
    if (!params.era_id) return null;

    return {
      id: params.era_id,
      //Make dynamic for future party integrations
      party: ExternalParty.ERA,
    };
  }
}

interface SubmitBaseProjectRequest {
  project: Project;
  otherContactIds?: number[];
  externalProjectIntegration?: ExternalProjectIntegration;
}

interface ExternalProjectIntegration {
  id: string;
  party: ExternalParty;
}
